import { Wordmark } from './Wordmark.js';
import { Stamp } from './Stamp.js';
import { useRoute } from '../lib/route.js';

const APP_URL = import.meta.env.VITE_APP_URL ?? 'http://localhost:5273';

const SECTIONS: ReadonlyArray<{ href: string; label: string }> = [
  { href: '#how', label: 'Como funciona' },
  { href: '#features', label: 'O que faz' },
  { href: '#roadmap', label: 'Roadmap' },
  { href: '#/atualizacoes', label: 'Atualizações' },
  { href: '#faq', label: 'Dúvidas' },
  { href: '#suggest', label: 'Sugerir' },
];

export function SiteNav() {
  const path = useRoute();
  const isLegalPage = path !== '/';
  // Logo aponta pra home (clear hash). Em página legal, vai pro topo da home.
  const logoHref = isLegalPage ? '/' : '#top';

  return (
    <header className="sticky top-0 z-40 border-b border-[var(--border-subtle)] bg-[var(--bg-paper)]/85 backdrop-blur-sm">
      <div className="mx-auto flex max-w-6xl items-center justify-between gap-4 px-6 py-4">
        <a href={logoHref} className="inline-flex items-baseline">
          <Wordmark size="md" />
        </a>

        {!isLegalPage ? (
          <nav className="hidden items-baseline gap-6 sm:flex">
            {SECTIONS.map((s) => (
              <a
                key={s.href}
                href={s.href}
                className="font-mono text-[11px] uppercase tracking-[0.18em] text-[var(--ink-tertiary)] hover:text-[var(--ink-primary)]"
              >
                {s.label}
              </a>
            ))}
          </nav>
        ) : (
          <a
            href="/"
            className="hidden font-mono text-[11px] uppercase tracking-[0.18em] text-[var(--ink-tertiary)] hover:text-[var(--ink-primary)] sm:inline-flex"
          >
            ← voltar pra início
          </a>
        )}

        <div className="flex items-center gap-3">
          <Stamp>beta</Stamp>
          <a
            href={APP_URL}
            className="rounded-sm bg-[var(--ink-primary)] px-4 py-2 font-sans text-sm text-[var(--bg-paper)] transition-opacity hover:opacity-90"
          >
            Entrar
          </a>
        </div>
      </div>
    </header>
  );
}
